module.exports = __webpack_public_path__ + "static/media/Trainbanner@3x.74dcf04f.png";